import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { clickAsLink } from 'helpers/link_helpers';
import { isBlank, isPresent } from 'helpers/string_helpers';

import ClickToCallRegistrationModal from '../../click_to_call/registration_modal';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';

class ActionFooter extends React.Component {
  static propTypes = {
    callListCompleted: PropTypes.bool,
    callListId: PropTypes.number,
    currentUser: PropTypes.shape({
      clickToCallEnabled: PropTypes.bool.isRequired,
      clickToCallRegistrationComplete: PropTypes.bool.isRequired,
      userIsAssumed: PropTypes.bool
    }).isRequired,
    editingTask: PropTypes.object,
    isCalling: PropTypes.bool,
    isValidTask: PropTypes.func.isRequired,
    phone: PropTypes.string,
    phoneNormalized: PropTypes.string,
    taskComplete: PropTypes.bool,
    onEndCall: PropTypes.func.isRequired,
    onEndCallList: PropTypes.func.isRequired,
    onNextRecord: PropTypes.func.isRequired,
    onSaveTasks: PropTypes.func.isRequired,
    onStartCall: PropTypes.func.isRequired
  }

  state = {
    registrationComplete: this.props.currentUser.clickToCallRegistrationComplete,
    showRegistrationModal: false
  };

  handleStartCall = (e) => {
    const { currentUser, phoneNormalized, onStartCall } = this.props;
    const { registrationComplete } = this.state;

    if (isPresent(phoneNormalized)) {
      if (currentUser.clickToCallEnabled && registrationComplete) {
        onStartCall(e);
      } else {
        this.setState({ showRegistrationModal: true });
      }
    } else {
      alert('No phone # provided');
    }
  }

  handleGoToCallList = (e) => {
    const { onEndCallList } = this.props;
    clickAsLink(window, '/contacts/call_lists', e);
    onEndCallList();
  }

  handleRegistrationModalClose = (registrationCompleted) => {
    this.setState({
      registrationComplete: registrationCompleted,
      showRegistrationModal: false
    });
  };

  callButton = () => {
    const { currentUser, onEndCall, isCalling, phoneNormalized } = this.props;

    const actionText = isCalling ? 'End Call' : 'Call';
    const handleClick = isCalling ? onEndCall : this.handleStartCall;
    const callButtonClasses = classNames({
      'btn': true,
      'btn-accent': !isCalling,
      'btn-danger': isCalling,
    });

    return (
      <button
        className={callButtonClasses}
        disabled={!currentUser.clickToCallEnabled || isBlank(phoneNormalized)}
        key="call-button"
        name="call-button"
        onClick={handleClick}
      >
        {actionText}
      </button>
    );
  }

  saveButton = (disabled) => {
    const { onSaveTasks } = this.props;

    const saveButtonClasses = classNames({
      'btn': true,
      'btn-primary': true
    });

    const xs = disabled ? { pointerEvents: 'none' } : {};

    return (
      <button
        className={saveButtonClasses}
        disabled={disabled}
        key="save-button"
        name="save-button"
        style={xs}
        onClick={onSaveTasks}
      >
        Save Task
      </button>
    );
  }

  saveButtonWrapper = () => {
    const { editingTask, isValidTask } = this.props;
    const validationError = isValidTask(editingTask);

    if (validationError !== null) {
      return (
        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{validationError}</Tooltip>}>
          <span style={{ display: 'inline-block', cursor: 'not-allowed' }}>
            {this.saveButton(true)}
          </span>
        </OverlayTrigger>
      );
    } else {
      return this.saveButton(false);
    }

  }

  endButton = () => {
    const { onEndCallList } = this.props;
    return (
      <button
        className={'btn btn-accent'}
        key="end-button"
        name="end-button"
        onClick={onEndCallList}
      >
        Exit
      </button>
    );
  }

  goToCallListButton = () => {
    return (
      <button
        className={'btn btn-primary'}
        key="goto-call-list-button"
        name="goto-call-list-button"
        onClick={this.handleGoToCallList}
      >
        Go To Call List
      </button>
    );
  }

  nextButton = () => {
    const { onNextRecord } = this.props;

    return (
      <button
        className="btn btn-primary"
        key="next-button"
        name="next-button"
        onClick={onNextRecord}
      >
        Next
      </button>
    );
  }

  render() {
    const buttons = this.renderButtons();
    return (
      <>
        {buttons.length > 0 &&
        <div className="bg-light position-absolute bottom-0 w-100 p-3 d-flex justify-content-start gap-2">
          {buttons}
        </div>
        }

        {this.renderClickToCallRegistrationModal()}
      </>
    );
  }

  renderButtons = () => {
    const { callListCompleted, callListId, isCalling, taskComplete } = this.props;

    if (callListCompleted) {
      return [this.endButton(), this.goToCallListButton()];
    }

    if (taskComplete) {
      if (isBlank(callListId)) {
        return [];
      } else {
        return [this.nextButton()];
      }
    }

    if (isCalling) return [this.callButton()];

    return [
      this.callButton(),
      this.saveButtonWrapper()
    ];
  }

  renderClickToCallRegistrationModal() {
    const { currentUser: user } = this.props;

    if (!(this.state.registrationComplete || user.userIsAssumed)) {
      return (
        <>
          <ClickToCallRegistrationModal
            currentUser={user}
            shown={this.state.showRegistrationModal}
            onClose={this.handleRegistrationModalClose}
          />
        </>
      );
    }
  }
}

export default ActionFooter;
